export enum ActiveSide {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}
